import React, { Component } from 'react';
import './star-rating.css';
import {BsStarFill, BsStar, BsStarHalf} from 'react-icons/bs';

class StarRating extends Component {
  constructor(props) {
    super(props);
    this.getStarElements = this.getStarElements.bind(this);
    this.getStarsOnRating = this.getStarsOnRating.bind(this);    
  }

  getStarsOnRating(starObject) {
    if(starObject.count === 0) {
      return null;
    }

    let resultDom = [];

    for(let i=0; i<starObject.count; i++) {
      resultDom.push(starObject.element);
    }
    return resultDom;
  }

  getStarElements(rating) {
    
    const starObject = {
      fullStarElement : {
        element: <BsStarFill className="iconSize" />,
        count: 0
      },
      emptyStarElement : {
        element: <BsStar className="iconSize" />,
        count: 0
      },
      halfStarElement : {
        element: <BsStarHalf className="iconSize" />,
        count: 0
      }
    }; 

    const totalRating = 5;
    starObject.fullStarElement.count = parseInt(rating);
    starObject.halfStarElement.count = ((parseInt(rating) - rating) < 0 ) ? 1 : 0;
    starObject.emptyStarElement.count = 
        totalRating - starObject.fullStarElement.count - starObject.halfStarElement.count;
   
    let fullStarList = this.getStarsOnRating(starObject.fullStarElement);
    let halfStarList = this.getStarsOnRating(starObject.halfStarElement);
    let emptyStarList = this.getStarsOnRating(starObject.emptyStarElement);

    return Array.prototype.concat(fullStarList, halfStarList, emptyStarList);
  }

  render() {    
    return(
      <span>
        {this.getStarElements(this.props.rating)}
      </span>
    )
  }
}

export default StarRating;